export default __webpack_public_path__ + "static/media/trophy-icon.a5254ecc.png";